import { Link } from "react-router-dom";
import { CheckCircle2, Mail, Key, Sparkles } from "lucide-react";

export default function Bienvenue() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16" data-testid="page-bienvenue">
      <div className="max-w-xl w-full mx-auto text-center">
        <div className="mb-6 flex items-center justify-center">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center"
            style={{
              background: "rgba(212,175,55,0.08)",
              border: "1px solid rgba(212,175,55,0.4)",
            }}
          >
            <CheckCircle2 size={30} strokeWidth={1.5} style={{ color: "#D4AF37" }} />
          </div>
        </div>

        <div className="text-[11px] uppercase tracking-[0.4em] mb-4" style={{ color: "#D4AF37" }}>
          Paiement confirmé
        </div>

        <h1 className="font-serif-display text-4xl md:text-5xl leading-tight mb-4">
          Bienvenue chez <span className="shimmer-text">Zerux !</span>
        </h1>

        <p className="text-zinc-300 text-sm mb-10 leading-relaxed">
          Merci pour votre achat. Votre accès est désormais actif.
        </p>

        {/* Encadré or avec identifiants */}
        <div
          className="text-left rounded-sm p-6 mb-6"
          style={{
            background: "rgba(212,175,55,0.04)",
            border: "1px solid rgba(212,175,55,0.4)",
          }}
          data-testid="welcome-credentials"
        >
          <div className="text-[10px] uppercase tracking-[0.3em] mb-4 text-center" style={{ color: "#D4AF37" }}>
            Vos identifiants d&rsquo;accès
          </div>

          <div className="flex items-start gap-3 mb-4">
            <Key size={16} strokeWidth={1.8} style={{ color: "#D4AF37", marginTop: 2, flexShrink: 0 }} />
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-1">Mot de passe</div>
              <div className="font-mono text-xl" style={{ color: "#F3E5AB" }} data-testid="welcome-password">
                Jenni2026
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Sparkles size={16} strokeWidth={1.8} style={{ color: "#D4AF37", marginTop: 2, flexShrink: 0 }} />
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-1">Site</div>
              <a
                href="https://bloc-zero-freeze.emergent.host"
                className="text-sm break-all gold-underline"
                style={{ color: "#F3E5AB" }}
                data-testid="welcome-site-link"
              >
                https://bloc-zero-freeze.emergent.host
              </a>
            </div>
          </div>
        </div>

        {/* Rappel email */}
        <div className="flex items-start gap-3 mb-8 px-4 py-3 rounded-sm text-left text-[12px] text-zinc-400 leading-relaxed"
             style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)" }}>
          <Mail size={14} strokeWidth={1.8} style={{ color: "#D4AF37", marginTop: 2, flexShrink: 0 }} />
          <span>
            Retrouvez ces informations dans votre e-mail de confirmation
            (<strong className="text-zinc-300">vérifiez vos spams</strong> si besoin).
          </span>
        </div>

        {/* CTA */}
        <Link
          to="/"
          data-testid="welcome-start-button"
          className="btn-gold-solid inline-flex items-center gap-2 h-12 px-8 rounded-sm text-xs uppercase tracking-[0.3em] font-semibold"
        >
          <Sparkles size={14} strokeWidth={1.8} />
          Accéder à Zerux
        </Link>

        <p className="mt-10 text-[11px] text-zinc-500 italic">
          Merci de votre confiance !<br />
          <span style={{ color: "#D4AF37" }}>Jennifer — HELP&rsquo;ADN</span>
        </p>
      </div>
    </div>
  );
}
